/**
 * @generated SignedSource<<74b73c651dc403ef3c240bb0cc08048c>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: nx generate-api-types
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from 'relay-runtime';
export type SavingsPlanStatus = "ACTIVE" | "CANCELED";
export type CancelSavingsPlanInput = {
  id: string;
};
export type CancelSavingsPlanMutation$variables = {
  input?: CancelSavingsPlanInput | null | undefined;
};
export type CancelSavingsPlanMutation$data = {
  readonly cancelSavingsPlan: {
    readonly id: string;
    readonly name: string | null | undefined;
    readonly status: SavingsPlanStatus | null | undefined;
  } | null | undefined;
};
export type CancelSavingsPlanMutation = {
  response: CancelSavingsPlanMutation$data;
  variables: CancelSavingsPlanMutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "input"
  }
],
v1 = [
  {
    "alias": null,
    "args": [
      {
        "kind": "Variable",
        "name": "input",
        "variableName": "input"
      }
    ],
    "concreteType": "SavingsPlan",
    "kind": "LinkedField",
    "name": "cancelSavingsPlan",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "id",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "name",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "status",
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "CancelSavingsPlanMutation",
    "selections": (v1/*: any*/),
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "CancelSavingsPlanMutation",
    "selections": (v1/*: any*/)
  },
  "params": {
    "cacheID": "b537f08df06700716e8fe56866a7aa6d",
    "id": null,
    "metadata": {},
    "name": "CancelSavingsPlanMutation",
    "operationKind": "mutation",
    "text": "mutation CancelSavingsPlanMutation(\n  $input: CancelSavingsPlanInput\n) {\n  cancelSavingsPlan(input: $input) {\n    id\n    name\n    status\n  }\n}\n"
  }
};
})();

(node as any).hash = "7314af09a8496801229fda62bb66a97b";

export default node;
